module.exports = __webpack_public_path__ + "img/cintia.926c0992.jpeg";